import { styled } from 'goober';
import { Typography } from '@shared/ui/typography/typography';
import { COLORS } from '@shared/config/colors/colors';

export const Policy = styled(Typography)`
    text-align: center;
`;

export const StyledLink = styled('a')`
    color: ${COLORS.bright_blue};
`;
